module.exports = __webpack_public_path__ + "static/media/10.251449d6.svg";